export default[
  {
    path: '/dataList/staffPromotion',
    component: resolve => require(['../page.vue'], resolve),
    meta: {
        title: '店员晋升',
        authLogin: true
    }
  },
]